import script from "./CookieConsentPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./CookieConsentPanel.vue?vue&type=script&setup=true&lang=js"

import "./CookieConsentPanel.vue?vue&type=style&index=0&id=518ccf4d&scoped=true&lang=css"

import exportComponent from "../../../web-sequence-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-518ccf4d"]])

export default __exports__